const sharedRules = [{
    description: 'No spaces',
    test: (newPassword) => !/\s/.test(newPassword),
}, {
    description: `No invalid characters (\\/"'-)`,
    test: (newPassword) => !/[-\\/"']/.test(newPassword),
}];

const strengthRules = {
    LOW: [
        {
            description: 'At least 4 characters long',
            test: (newPassword) => /.{4,}/.test(newPassword),
        },
        ...sharedRules
    ],
    MEDIUM: [
        {
            description: 'At least 6 characters long',
            test: (newPassword) => /.{6,}/.test(newPassword),
        },
        {
            description: 'At least 1 letter',
            test: (newPassword) => /[a-zA-Z]/.test(newPassword),
        },
        {
            description: 'At least 1 number',
            test: (newPassword) => /[0-9]/.test(newPassword),
        },
        ...sharedRules
    ],
    HIGH: [
        {
            description: 'At least 8 characters long',
            test: (newPassword) => /.{8,}/.test(newPassword),
        },
        {
            description: 'At least 1 uppercase letter',
            test: (newPassword) => /[A-Z]/.test(newPassword),
        },
        {
            description: 'At least 1 lowercase letter',
            test: (newPassword) => /[a-z]/.test(newPassword),
        },
        {
            description: 'At least 1 number',
            test: (newPassword) => /[0-9]/.test(newPassword),
        },
        ...sharedRules
    ],
    HIGHEST: [
        {
            description: 'At least 8 characters long',
            test: (newPassword) => /.{8,}/.test(newPassword),
        },
        {
            description: 'At least 1 uppercase letter',
            test: (newPassword) => /[A-Z]/.test(newPassword),
        },
        {
            description: 'At least 1 lowercase letter',
            test: (newPassword) => /[a-z]/.test(newPassword),
        },
        {
            description: 'At least 1 number',
            test: (newPassword) => /[0-9]/.test(newPassword),
        },
        {
            description: 'At least 1 special character (@%+!#$^?:.~[]{}|&*()_=+;,<>`)',
            test: (newPassword) => /[@%+!#$^?:.~[\]{}|&*()_=;,<>`]/.test(newPassword),
        },
        ...sharedRules
    ],
};

/**
 * Get rules for a password strength.
 * @param {string} strength Must be 'LOW', 'MEDIUM', 'HIGH', or 'HIGHEST'.
 * @returns An array of rule objects with a description and test function.
 */
export function getStrengthRules(strength) {
    // validate the strength argument
    if (typeof strength !== 'string' || !strength.match(/LOW|MEDIUM|HIGH|HIGHEST/)) {
        throw `Invalid \`strength\` argument. Valid arguments are: 'LOW', 'MEDIUM', 'HIGH', OR 'HIGHEST'.`;
    }

    return strengthRules[strength];
}
